import { QueryFn } from '@percent/education-hosted-form/hooks/useQuery/useQuery.types'
import { GetCountriesResponse } from './countries.types'

export const getCountriesAction: QueryFn<[string], GetCountriesResponse> = async (client, [_]) => {
  const response = await client.get(`v1/countries`)

  return response.data
}
